import { makeAutoObservable } from 'mobx'
import { type IResponseRecurringBroadcastById } from 'entities/Broadcast/api/types'
import { BroadcastBaseStatistic } from 'entities/Broadcast/model/BroadcastBaseStatistic'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class BroadcastRecurringStatistic {
  readonly broadcastBaseStatistic: BroadcastBaseStatistic
  constructor(
    {
      contacts_count,
      total_statistics,
      total_analytics,
      is_track_conversion,
    }: IResponseRecurringBroadcastById,
    private _entities: IEntitiesStore
  ) {
    const unsubscribed_count = total_statistics.opt_out_count
    const no_replies_count = total_statistics.no_replies_count
    const reply_count = total_statistics.reply_count
    const success_count = total_statistics.success_count
    const total_count = total_statistics.total_count
    const in_progress_count = total_statistics.in_progress_count
    const quiet_hours_count = total_statistics.quiet_hours_count
    const skipped_count = total_statistics.skipped_count
    const failed_count = total_statistics.failed_count
    const clicks_count = total_analytics.clicks

    const conversions_count = total_analytics.clicks

    this.broadcastBaseStatistic = new BroadcastBaseStatistic(this._entities, {
      contacts_count,
      is_track_conversion,
      total_count,
      in_progress_count,
      quiet_hours_count,
      success_count,
      skipped_count,
      reply_count,
      no_replies_count,
      clicks_count,
      conversions_count,
      revenue_cost: '',
      failed_count,
      unsubscribed_count,
    })

    makeAutoObservable(this)
  }

  get filters() {
    return this.broadcastBaseStatistic.filters
  }
}
